<template>
  <div class="cascader">
    <div>
      <cascader-field
        v-for="(item, index) in cascaderFields"
        :key="item.key"
        :value="item.value"
        :is-transition="index !== 0"
        :placeholder="placeholders[index]"
        @click="onClickField(index)"
      />
      <div v-if="levelsNum < requiredNum" class="van-field-border">
        <van-field v-for="item in issue.items" :key="item.id" v-model="item.value" placeholder="详细地址" />
      </div>
    </div>
    <van-popup :close-on-click-overlay="false" ref="popup" v-model="popupFlag" round position="bottom">
      <van-picker
        show-toolbar
        :columns="currentColumn.children || []"
        @cancel="onCancel"
        @confirm="onConfirm"
        value-key="content"
        class="cascader-picker"
      >
        <template v-slot:option="scope">
          <div class="custom-picker-item">
            {{ scope.content }}
          </div>
        </template>
      </van-picker>
    </van-popup>

    <div class="vote-answer vote-answering-wrapper" v-if="showVoteProgress">
      <template v-if="voteItems.length">
        <div style="margin-bottom: 12px">
          投票排名
        </div>
      </template>
      <choice-vote-content :items="voteItems"/>
      <template v-if="voteItems.length > 5">
        <van-button type="primary" size="small" block @click="onShowMoreRank">查看更多排名</van-button>
      </template>
    </div>
  </div>
</template>

<script>
import CascaderField from './CascaderField'
import { cascadePlaceholders } from './types'
import vote from './vote'
export default {
  name: 'Cascader',
  components: { CascaderField },
  mixins: [vote],
  changeExpr: 'watchExpr',
  data() {
    return {
      fieldValue: '',
      popupFlag: false,
      cascaderFields: [],
      currentColumn: {},
      levelGroups: [],
      popGroups: []
    }
  },
  computed: {
    watchExpr() {
      let ids = (this.cascaderFields || []).map(item => item.selectId)
      let vals = this.issue.items.map(i => i.value)
      return ids.join('-') + ',' + vals.join('-')
    },
    placeholders() {
      let res = cascadePlaceholders.get(this.question.question_type)
      if (res) return res
      return this.question.issue.placeholder.split('/').map(item => `${item}`)
    },
    selects: {
      get() {
        return this.question.issue.value
      },
      set(v) {
        this.question.issue.value = (v || []).reduce((r, i) => {
          if (i.selectId) {
            r.push(i.selectId)
          }
          return r
        }, [])
      }
    },
    detail() {
      return this.question.issue.fillContext || {}
    },
    requiredNum() {
      return this.question.issue.requiredNum
    },
    levelsNum() {
      return this.question.issue.levelsNum
    },
    leaves() {
      let requiredNum = this.requiredNum
      let leaves = this.levelsNum
      return Math.min(requiredNum, leaves)
    }
  },
  created() {
    this.is_init = false
    this.initCascader()
  },
  watch: {
    'issue.groups'(){
      this.initCascader()
      this.$nextTick(()=>{
        this.initAnswers()
      })
    }
  },
  methods: {
    initCascader() {
      if (this.is_init) return
      if (!this.issue.groups.length) return
      this.levelGroups.push(this.issue.groups)
      this.cascaderFields.push(this.getCascader(this.issue.groups, this.question.id))
      this.is_init = true
    },
    getCascader(groups, key) {
      let children = groups.map(item => {
        return {
          id: item.id,
          content: item.content
        }
      })
      return {
        key,
        children,
        value: '',
        selectId: ''
      }
    },
    onClickField(index) {
      this.popupFlag = true
      this.currentColumn = this.cascaderFields[index]
      this.popGroups = this.levelGroups.splice(index + 1)
    },
    handlerPopGroups(length) {
      if (length === 0) {
        // 清空弹出队列
        this.popGroups.length = 0
      } else {
        if (this.popGroups.length) {
          // 把弹出的队列添加回去
          this.levelGroups.push(...this.popGroups)
          this.popGroups.length = 0
        }
      }
    },
    onCancel() {
      this.popupFlag = false
      this.handlerPopGroups()
    },
    onConfirm(item, index) {
      this.popupFlag = false
      let currentGroups = this.levelGroups[this.levelGroups.length - 1]
      let currentGroup = currentGroups[index]

      this.currentColumn.value = item.content // 更新 当前 field
      this.currentColumn.selectId = item.id // 更新选择Id
      let idx = this.cascaderFields.findIndex(item => item === this.currentColumn)
      if (idx !== this.cascaderFields.length - 1 && idx > -1) {
        if (this.cascaderFields[idx + 1].key !== item.id) {
          this.cascaderFields.splice(idx + 1)
        } else {
          this.handlerPopGroups()
          return
        }
      }
      if (
        currentGroup.nextLevelOptions &&
        currentGroup.nextLevelOptions.length &&
        this.cascaderFields.length < this.requiredNum
      ) {
        // 如果还有下一级 添加
        this.cascaderFields.push(this.getCascader(currentGroup.nextLevelOptions, item.id))
        this.levelGroups.push(currentGroup.nextLevelOptions)
      }
      this.selects = this.cascaderFields
      this.handlerPopGroups(0)
    },
    initAnswers(){
      this.$nextTick(() => {
        if (this.selects.length) {
          let ids = this.selects.slice()
          let groups = this.issue.groups
          ids.forEach((id, index) => {
            if (id && typeof id === 'string') {
              let group = groups.find(item => item.id === id)
              if (!group) return
              groups = group.nextLevelOptions || []
              if (groups.length && this.cascaderFields.length < this.requiredNum) {
                this.levelGroups.push(groups)
                this.cascaderFields.push(this.getCascader(groups, id))
              }
              this.cascaderFields[index].selectId = id
              this.cascaderFields[index].value = group.content
            }
          })
        }
      })
    }
  },
  mounted() {
    this.initAnswers()
  }
}
</script>

<style lang="scss">
.cascader-picker {
  .custom-picker-item {
    height: 100%;
    overflow: hidden;
    padding: 0 12px;
    box-sizing: border-box;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-height: 22px;
    //text-overflow: -o-ellipsis-lastline;
    text-overflow: ellipsis;
    line-clamp: 2;
  }
}
</style>
